import React from 'react';
import { PROPERTY_IMAGES_URL, AGENCY_LOGOS_URL } from "../../../../constants/url";

const TemplateBold = ({ property, images, currentagency }) => {
  const imagesArr = images?.slice(0, 5).map((img) => `${PROPERTY_IMAGES_URL}${img.propertyimages}`) || [];
  
  const formatPrice = (num) => {
    if (num >= 10000000) return `${(num / 10000000).toFixed(2)} Crore`;
    if (num >= 100000) return `${(num / 100000).toFixed(2)} Lakh`;
    return num?.toLocaleString() || "0";
  };

  return (
    <div style={{ width: '1080px', height: '1920px', backgroundColor: '#56C662', position: 'relative', overflow: 'hidden', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', fontFamily: 'sans-serif' }}>
      {/* Decorative Gradients */}
      <div style={{ position: 'absolute', top: '-200px', left: '-200px', width: '800px', height: '800px', backgroundColor: 'white', opacity: 0.2, borderRadius: '50%', filter: 'blur(100px)' }} />
      <div style={{ position: 'absolute', bottom: '-100px', right: '-100px', width: '600px', height: '600px', backgroundColor: 'black', opacity: 0.2, borderRadius: '50%', filter: 'blur(80px)' }} />

      {/* Main Image Grid */}
      <div style={{ height: '900px', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px', padding: '40px', position: 'relative', zIndex: 10 }}>
        <div style={{ gridColumn: 'span 2', height: '550px', borderRadius: '60px', overflow: 'hidden', border: '12px solid rgba(255,255,255,0.3)', boxShadow: '0 30px 60px rgba(0,0,0,0.2)' }}>
          <img 
            src={imagesArr[0]} 
            crossOrigin="anonymous"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            alt="main"
          />
        </div>
        <div style={{ height: '280px', borderRadius: '40px', overflow: 'hidden', border: '6px solid rgba(255,255,255,0.2)' }}>
          <img 
            src={imagesArr[1]} 
            crossOrigin="anonymous"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            alt="sub1"
          />
        </div>
        <div style={{ height: '280px', borderRadius: '40px', overflow: 'hidden', border: '6px solid rgba(255,255,255,0.2)' }}>
          <img 
            src={imagesArr[2]} 
            crossOrigin="anonymous"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            alt="sub2"
          />
        </div>
      </div>

      {/* Dynamic Content */}
      <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', padding: '0 60px 60px 50px', position: 'relative', zIndex: 10 }}>
        <div style={{ backgroundColor: 'rgba(0,0,0,0.9)', padding: '40px', borderRadius: '80px', boxShadow: '0 40px 80px rgba(0,0,0,0.3)', marginBottom: '40px', borderTop: '10px solid #56C662' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '30px' }}>
            <h1 style={{ fontSize: '80px', fontWeight: 900, lineHeight: 0.9, textTransform: 'uppercase', fontStyle: 'italic', color: 'white', margin: 0 }}>
              {property?.PropertyType || "House"} <br/>
              <span style={{ color: '#56C662' }}>For {property?.PropertyPurpose || "Sale"}</span>
            </h1>
            <div style={{ backgroundColor: '#56C662', color: 'black', padding: '15px 30px', borderRadius: '20px', fontSize: '32px', fontWeight: 900, transform: 'skewX(-10deg)' }}>
              HOT DEAL
            </div>
          </div>
          
          <p style={{ fontSize: '40px', color: '#ccc', fontWeight: 'bold', marginBottom: '40px', textTransform: 'uppercase', letterSpacing: '-1px', margin: 0 }}>
            📍 {property?.SubLocation}, {property?.ProvinceName}
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '30px' }}>
            <div style={{ backgroundColor: 'rgba(255,255,255,0.05)', padding: '25px', borderRadius: '30px', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span style={{ fontSize: '60px', marginBottom: '10px' }}>🛏️</span>
              <p style={{ fontSize: '40px', fontWeight: 900, color: 'white', margin: 0 }}>{property?.bedrooms || 0}</p>
            </div>
            <div style={{ backgroundColor: 'rgba(255,255,255,0.05)', padding: '25px', borderRadius: '30px', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span style={{ fontSize: '60px', marginBottom: '10px' }}>🚿</span>
              <p style={{ fontSize: '40px', fontWeight: 900, color: 'white', margin: 0 }}>{property?.bathrooms || 0}</p>
            </div>
            <div style={{ backgroundColor: 'rgba(255,255,255,0.05)', padding: '25px', borderRadius: '30px', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span style={{ fontSize: '60px', marginBottom: '10px' }}>📐</span>
              <p style={{ fontSize: '32px', fontWeight: 900, color: 'white', margin: 0 }}>{Math.floor(property?.propertysizesqft || 0)}</p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div style={{ marginTop: 'auto', display: 'flex', flexDirection: 'column', gap: '30px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
               {currentagency?.agencylogo && (
                <img 
                  src={`${AGENCY_LOGOS_URL}${currentagency.agencylogo}`}
                  crossOrigin="anonymous"
                  style={{ height: '100px', width: '100px', objectFit: 'contain', borderRadius: '50%', border: '6px solid white' }}
                  alt="logo"
                />
              )}
              <div>
                <p style={{ fontSize: '48px', fontWeight: 900, color: 'black', margin: 0 }}>Rs {formatPrice(property?.propertyprice)}</p>
                <p style={{ fontSize: '28px', color: 'white', fontWeight: 'bold', opacity: 0.9, textTransform: 'uppercase', letterSpacing: '2px', margin: 0 }}>Call: {currentagency?.mobileno}</p>
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
               <p style={{ color: 'black', fontSize: '24px', fontWeight: 900, textTransform: 'uppercase', margin: 0, letterSpacing: '4px' }}>propertians.com</p>

            </div>
          </div>
          
          <div style={{ width: '100%', backgroundColor: 'black', color: '#56C662', fontSize: '60px', fontWeight: 900, textAlign: 'center', padding: '40px 0', borderRadius: '50px', boxShadow: '0 30px 60px rgba(0,0,0,0.3)', textTransform: 'uppercase' }}>
            WhatsApp Now!
          </div>
        </div>
      </div>

      {/* Hidden Preloaders */}
      <div style={{ display: 'none' }}>
        {imagesArr.map((url, i) => <img key={i} src={url} crossOrigin="anonymous" alt="p" />)}
        {currentagency?.agencylogo && <img src={`${AGENCY_LOGOS_URL}${currentagency.agencylogo}`} crossOrigin="anonymous" alt="l" />}
      </div>
    </div>
  );
};

export default TemplateBold;
